// Cloudflare Image Transformations (enabled on the br.lk zone 2026-07-10).
// Wraps a CMS image URL in /cdn-cgi/image/ so the edge serves a resized
// AVIF/WebP (format=auto negotiates per browser) instead of the original
// full-size PNG/JPEG. 296 KB PNG → ~15 KB AVIF measured on the payment-
// gateway post's hero. Free tier: 5,000 unique transformations/month —
// unique means URL+options, so keep the width set small and stable.

const CDN_PREFIX = 'https://br.lk/cdn-cgi/image/'

// Only WordPress uploads are worth routing through the resizer. Skip SVG
// (vector), GIF (animation frames count per-frame), and anything already
// wrapped or non-CMS.
const RESIZABLE = /^https:\/\/cms\.br\.lk\/wp-content\/uploads\/.+\.(png|jpe?g|webp)$/i

export function isResizable(url) {
  return typeof url === 'string' && RESIZABLE.test(url) && !url.includes('/cdn-cgi/image/')
}

export function cfImage(url, width = 760, quality = 82) {
  if (!isResizable(url)) return url
  return `${CDN_PREFIX}format=auto,quality=${quality},width=${width},fit=scale-down/${url}`
}

// Standard width ladder: phone (380), phone@2x / tablet (760), desktop (1140).
export const CONTENT_WIDTHS = [380, 760, 1140]

export function cfSrcSet(url, widths = CONTENT_WIDTHS) {
  if (!isResizable(url)) return undefined
  return widths.map((w) => `${cfImage(url, w)} ${w}w`).join(', ')
}
